import axios from 'axios'
import { debounce } from 'lodash'

const api = axios.create({
    baseURL: '/api/',
    headers: {
        'Content-Type': 'application/json',
    },
})
const formDataApi = axios.create({
    baseURL: '/api/',
    headers: {
        'Content-Type': 'multipart/form-data',
    },
})
//const authApi = axios.create()

const configureEventHandlers = function(onRequest, onRequestError, onResponse, onResponseError) {
    api.interceptors.request.use(onRequest, onRequestError)
    api.interceptors.response.use(onResponse, onResponseError)

    formDataApi.interceptors.request.use(onRequest, onRequestError)
    formDataApi.interceptors.response.use(onResponse, onResponseError)
}

const sendAndReturnData = function(p) {
    return p.then(res => {
        return (res && res.data) || null
    })
}

var apiModule = {
    configureEventHandlers,

    sendAndReturnData,

    client: api,

    get: function(url, params, config) {
        return sendAndReturnData(
            api.get(url, {
                params,
                ...config,
            }),
        )
    },

    put: function(url, payload) {
        return sendAndReturnData(api.put(url, payload))
    },

    patch: function(url, payload) {
        return sendAndReturnData(api.patch(url, payload))
    },

    post: function(url, payload, config) {
        return sendAndReturnData(api.post(url, payload, config))
    },

    delete: function(url) {
        return sendAndReturnData(api.delete(url))
    },

    postForm: function(url, payload) {
        return sendAndReturnData(formDataApi.post(url, payload))
    },

    getTeams: function() {
        return this.get('/team/getAllActive')
    },

    getEvents: function() {
        return this.get('/event/getCurrentList')
    },

    logout: function() {
        return this.post('/user/logout', null, { silent: true })
    },

    refreshPermissions: function() {
        return this.post('/user/refreshPermissions')
    },

    debouncedErrorLog: debounce(function(payload) {
        try {
            return apiModule.post(`logging/js`, payload)
        } catch (e) {
            console.error('Failed to log error', e)
        }
    }, 5000),

    logClientError: function(payload) {
        this.debouncedErrorLog(payload)
    },

    getAppVersion: function() {
        return this.get('healthcheck/version')
    },
}

export default apiModule
